// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"50":"3478b976","136":"ec88dd06","147":"8e44c7a2","198":"196c909d","235":"088f44b7","323":"d9702039","488":"6e344578","496":"6fa46188","498":"2ead48cc","681":"6a8c8c18","703":"57c5b62b","815":"68232cc4"}[chunkId] + ".chunk.js";
};